import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// BrowserRouter keeps the window's scroll position between pages,
// so every new page would otherwise open wherever the last one was left.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    // Leave in-page anchor links (#section) to the browser
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
